/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { UserInfo } from "../../../shared/types/user-info";
import { Company } from "./company.type";
import { CompanyTableService } from "./company-table.service";

@Component({
  selector: "app-companies",
  templateUrl: "./companies.component.html",
  styleUrls: ["./companies.component.scss"],
})
export class CompaniesComponent implements OnInit {
  currentUser: UserInfo;
  tableConfig: DataTable<Company>;

  constructor(
    public companyTableService: CompanyTableService,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Lifecycle Methods

  ngOnInit(): void {
    this.tableConfig = this.companyTableService.getCompaniesTableConfig();
  }

  // #endregion

  // #region Handlers

  onAddCompany(): void {
    this.addCompany();
  }

  // #endregion

  // #region Private Methods

  private addCompany(): void {
    this.router.navigate(["/companies/create"]);
  }

  // #endregion
}
